import {
  ScreenType,
  type ProfileFilter,
} from "@package/ui-gql/index-data-access";
import { type WritableDraft } from "immer";
import { sortBy, uniq } from "lodash";
import { useMemo, useState } from "react";
import { SCREEN_TYPE_TO_DISPLAY } from "../../constants/constants";
import { useItemGridFilterContext } from "../ItemGridFilter/context-item-grid-filter";
import {
  ItemGridFilterDataList,
  type FilterValueEntry,
} from "../ItemGridFilter/ItemGridFilterDataList";

type SupportedFilter = ProfileFilter | null | undefined;

export function ItemGridFilterScreenType() {
  const [query, setQuery] = useState<string>("");

  const { filter, updateFilterState } =
    useItemGridFilterContext<ProfileFilter>();

  const filterWithScreenType: SupportedFilter = filter;
  const items = useMemo<FilterValueEntry[]>(() => {
    const values: FilterValueEntry[] =
      Object.values(ScreenType)
        .map((type) => {
          const id = type;
          const name = SCREEN_TYPE_TO_DISPLAY[type];
          const checked = filterWithScreenType?.type?.includes(id) ?? false;
          return {
            id,
            name,
            checked,
          };
        })
        .filter((entry) =>
          entry.name.toLowerCase().includes(query.toLowerCase()),
        ) ?? [];

    return sortBy(values, (entry) => entry.name);
  }, [filterWithScreenType?.type, query]);

  return (
    <ItemGridFilterDataList
      items={items}
      property="type"
      text="Screen Type"
      onQueryValueChanged={setQuery}
      onRequestFilterReset={() =>
        updateFilterState((draft: WritableDraft<SupportedFilter>) => {
          if (draft) {
            delete draft.type;
          }
        })
      }
      onRequestFilterUpdate={(id, include) =>
        updateFilterState((draft: WritableDraft<SupportedFilter>) => {
          if (draft) {
            if (include) {
              draft.type = uniq([...(draft.type ?? []), id as ScreenType]);
            } else if (draft.type?.length) {
              draft.type = draft.type.filter((type) => type !== id);
            }

            if (!draft.type?.length) {
              delete draft.type;
            }
          }
        })
      }
      onSelectAllChanged={(checked) => {
        updateFilterState((draft: WritableDraft<SupportedFilter>) => {
          if (draft) {
            if (checked) {
              draft.type = Object.values(ScreenType);
            } else {
              delete draft.type;
            }
          }
        });
      }}
    />
  );
}
